export enum QuotationArticles {
  AUTOMOVILES_PRODUCTO_AUTOMOVILES_RC = "001006",
  AUTOMOVILES_PRODUCTO_AUTOMOVILES = "001203",
  AUTOMOVILES_AUTOMOVILES_CONTADO = "001205",
  AUTOMOVILES_AUTOMOVILES_RC_CONTADO = "001206",
  AUTOMOVILES_MYWAY_HAZLO_A_TU_MANERA = "001303",
  AUTOMOVILES_RC_MYWAY_HAZLO_A_TU_MANERA = "001306",
  AUTOMOVILES_AUTOMOVILES_FRANQ_VARIABLE = "001603",
  HOGAR_COMBINADO_FAMILIAR = "000027",
  ROBO_ROBO_WEB = "001010",
  INTEGRAL_DE_CONSORCIO = "000026",
  EFECTOS_PERSONALES = "001015",
  RESPONSABILIDAD_CIVIL_WEB_RESP_CIVIL_HECHOS_PRIVADOS = "001108",
  RESPONSABILIDAD_CIVIL_WEB_RC_EMBARCACIONES_DE_PLACER = "001808",
  INTEGRAL_DE_COMERCIO_WEB = "001128",
  INCENDIO_WEB = "001101",
  VIDA_OBLIGATORIO_PERSONAL_DOMESTICO = "002089"
}